<ul class="checkbox-list d-flex flex-column custom-scroll p-0 m-0" [class.view-mode]="viewOnly">
    @if (!disabled && value?.length > 1 && !viewOnly) {
        <li
            class="select-all checkbox py-1 px-3 my-0 position-sticky"
            helpTooltip
            [helpContentId]="helpContentId"
            [helpDisabled]="helpDisabled">
            <label [class.disabled]="disabled">
                <ws-tri-state-checkbox [ngModel]="isAllChecked"
                                       (ngModelChange)="selectAll()"
                                       [disabled]="disabled">
                </ws-tri-state-checkbox>
                Select All
            </label>
        </li>
    }
    @for (listItem of value; track listItem) {
        @if (!viewOnly) {
            <li class="checkbox py-1 px-3 my-0"
                helpTooltip
                [helpContentId]="helpContentId"
                [helpDisabled]="helpDisabled">
                <label [class.disabled]="disabled">
                    <ws-tri-state-checkbox type="checkbox"
                                           [ngModel]="listItem.checked"
                                           (ngModelChange)="checkChanged($event, listItem)"
                                           [disabled]="disabled">
                    </ws-tri-state-checkbox>
                    {{ listItem.label }}
                </label>
            </li>
        }
        @if (viewOnly && listItem.checked) {
            <li>
                <span>{{ listItem.label }}</span>
            </li>
        }
    }
</ul>

